import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import "./LoadingSpinner.scss"

class LoadingSpinnerSmall extends Component {
  render() {
    return (
        <div className="hrb-loading-spinner-small">
            <FontAwesomeIcon icon={faSpinner} size="1x" pulse />
        </div>
    );
  }
}

export default LoadingSpinnerSmall;